"use client";
import * as React from "react";
const SvgFileDownloadFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 14 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M13.5 5.65H9.79V0H4.2v5.65H.5L7 12.23zm-13 8.47V16h13v-1.88z" }));
export {
  SvgFileDownloadFilled as default
};
